import script from "./ForgotPasswordDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordDialog.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordDialog.vue?vue&type=style&index=0&id=0f4920c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f4920c9"]])

export default __exports__